/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S1_P1Inputs */

const en_guide_json_syntax_errors_s1_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The most common JSON error is a trailing comma after the last item in an object or array. JavaScript allows this, but JSON does not.`)
};

const ko_guide_json_syntax_errors_s1_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 흔한 JSON 오류는 객체나 배열의 마지막 항목 뒤에 오는 후행 쉼표입니다. JavaScript에서는 허용되지만, JSON에서는 허용되지 않습니다.`)
};

const ja_guide_json_syntax_errors_s1_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も一般的なJSONエラーは、オブジェクトや配列の最後の項目の後にある末尾のカンマです。JavaScriptではこれが許可されていますが、JSONでは許可されていません。`)
};

/**
* | output |
* | --- |
* | "The most common JSON error is a trailing comma after the last item in an object or array. JavaScript allows this, but JSON does not." |
*
* @param {Guide_Json_Syntax_Errors_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s1_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s1_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s1_p1(inputs)
	return ja_guide_json_syntax_errors_s1_p1(inputs)
});